/**
 * Static iso_code → uppercase English label map (frontend-only, research D2).
 * Values mirror the curated copy in `content/landing.ts` so the dashboard rows
 * read identically to the marketing language rows. The API `name` field is the
 * native name ("Norsk"); this supplies the English label ("NORWEGIAN").
 */
const ENGLISH_NAMES: Record<string, string> = {
  no: 'NORWEGIAN',
  nb: 'NORWEGIAN',
  is: 'ICELANDIC',
  de: 'GERMAN',
  fr: 'FRENCH',
  es: 'SPANISH',
  it: 'ITALIAN',
  pt: 'PORTUGUESE',
  nl: 'DUTCH',
  sv: 'SWEDISH',
  el: 'GREEK',
}

/**
 * Uppercase English label for a language. Falls back to the uppercased native
 * name so a newly seeded language never renders a blank label.
 */
export function englishName(isoCode: string, fallbackNative: string): string {
  return ENGLISH_NAMES[isoCode] ?? fallbackNative.toUpperCase()
}
